import mrpStyles from './../mrp.json'

export default {
  borderBottom: `1px solid ${mrpStyles.colors.PrimaryGrey}`,
  navigationBarMargin: '0 -16px',
  scrollContainerMarginLeft: {
    small: '-8px',
    medium: '-28px',
    large: '-32px'
  },
  sticky: {
    small: {
      offset: '46px'
    },
    medium: {
      marginTop: 0
    },
    large: {
      marginTop: 0
    }
  }
}
